import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AddressSuggestions } from 'react-dadata';
import 'react-dadata/dist/react-dadata.css';
import { shippingActions, setAddressAndCalculate } from '../../features/shipping';
import { shippingSelectors } from '../../features/shipping';
import { cartSelectors } from '../../features/cart';
import './AddressInput.css';

import { DADATA_API_KEY } from '../../config/secrets';

const AddressInput = ({
                          onAddressSelect,
                          placeholder = "Введите адрес доставки...",
                          autoCalculate = true,
                          cartItems: propCartItems,
                      }) => {
    const dispatch = useDispatch();

    const savedAddress = useSelector(shippingSelectors.selectFullAddress);
    const reduxCartItems = useSelector(cartSelectors.selectCartItems);

    const cartItems = propCartItems || reduxCartItems;

    const handleAddressChange = useCallback((suggestion) => {
        if (!suggestion) return;

        const regionKladr = suggestion.data.region_kladr_id || '';
        const addressData = {
            fullAddress: suggestion.value,
            unrestrictedValue: suggestion.unrestricted_value,
            city: suggestion.data.city_with_type || suggestion.data.settlement_with_type || suggestion.data.region_with_type,
            postalCode: suggestion.data.postal_code,
            region: suggestion.data.region_with_type,
            stateCode: regionKladr.substring(0, 2),
            street: suggestion.data.street_with_type,
            house: suggestion.data.house,
            flat: suggestion.data.flat,
            fiasId: suggestion.data.fias_id,
            geoLat: suggestion.data.geo_lat,
            geoLon: suggestion.data.geo_lon,
        };

        if (autoCalculate) {
            dispatch(setAddressAndCalculate(addressData, cartItems));
        } else {
            dispatch(shippingActions.setAddress(addressData));
        }


        if (onAddressSelect) {
            onAddressSelect(addressData);
        }
    }, [dispatch, cartItems, autoCalculate, onAddressSelect]);

    return (
        <div className="address-input-container">
            <AddressSuggestions
                token={DADATA_API_KEY}
                defaultQuery={savedAddress}
                onChange={handleAddressChange}
                inputProps={{
                    placeholder: placeholder,
                    className: 'address-dadata-input',
                }}
                hintText="Выберите вариант или продолжите ввод..."
                count={5}
                filterFromBound="city"
                filterToBound="house"
            />
        </div>
    );
};

export default AddressInput;